export const APPLICATION_DECISION = 'applicationDecision';
export const APPLICATION_STATUS_FETCH_FAILED = 'applicationStatusFetchFailed';
export const QUOTE_RECEIVED = 'quoteReceived';
export const VERID_ERROR = 'veridError';
export const VERID_QUESTIONS_FETCH_FAILED = 'veridQuestionsFetchFailed';
export const VERID_QUESTIONS_RECEIVED = 'veridQuestionsReceived';
export const VERID_TIMER_EXPIRED = 'veridTimerExpired';
export const LANDING_FORM_SUBMITTED = "landingFormSubmitted";
export const PROSPECT_VALIDATED = "prospectValidated";
export const CHECK_YOUR_RATE_FORM_SUBMITTED = "checkYourRateFormSubmitted";
export const SELECT_OFFER_FORM_SUBMITTED = "selectOfferFormSubmitted";
export const MARKET_CODE_CHANGED = 'marketCodeChanged';
export const APPLICATION_DATA_RESET = 'applicationDataReset';
export const CUSTOMER_INFO_FROM_TOKEN_RECEIVED = 'customerInfoFromTokenReceived';
export const LOAN_APPLICATION_RECEIVED = 'loanApplicationReceived';
export const FIRE_DTM_CONTROLLER = 'fireDtmController';
export const PERSONALIZED_QUOTE_RECEIVED = 'personalizedQuoteReceived';
export const UPDATE_APRS = 'updateAprs';
export const ACCOUNT_INFO = 'ACCOUNT_INFO';
export const ACCOUNT_INFO_UPDATE ="ACCOUNT_INFO_UPDATE";
export const ACCOUNT_TERM_INFO_UPDATE ="ACCOUNT_TERM_INFO_UPDATE";
export const EXTERNAL_BANK_ACCOUNT_LIST = 'EXTERNAL_BANK_ACCOUNT_LIST';
export const EXTERNAL_BANK_ACCOUNT_LIST_RESET = 'EXTERNAL_BANK_ACCOUNT_LIST_RESET';
export const ACCOUNT_SIGN_INFO_UPDATE = "ACCOUNT_SIGN_INFO_UPDATE";
export const COMPONENT_SWITCH_INFO = "COMPONENT_SWITCH_INFO";
export const CUSTOMER_INFORMATION = "CUSTOMER_INFORMATION";
export const UPDATE_OFFER_DETAILS = "UPDATE_OFFER_DETAILS";
export const SPINNER_TOGGLE = "SPINNER_TOGGLE";
export const SHOW_COMMON_ALERT = "SHOW_COMMON_ALERT";
export const ACCOUNT_TERM_CONDITION_UPDATE = "ACCOUNT_TERM_CONDITION_UPDATE";
export const UPLOAD_PENDING_DOCUMENT = "UPLOAD_PENDING_DOCUMENT";
export const COMPLETE_UPLOAD_DOCUMENT = "COMPLETE_UPLOAD_DOCUMENT";
export const COMPLETE_UPLOAD_DOCUMENT_STATUS = "COMPLETE_UPLOAD_DOCUMENT_STATUS";
export const DECISION_API_RESPONSE = "DECISION_API_RESPONSE";
export const GENERATE_OTP_DATA = "GENERATE_OTP_DATA";
export const SET_BANK_ACCOUNT_INFO = "SET_BANK_ACCOUNT_INFO";
export const SET_VERID_QUESTIONS = "SET_VERID_QUESTIONS";
export const SET_KBV_QUESTIONS = "SET_KBV_QUESTIONS";
export const SET_FOLLOWUP_QUESTIONS = "SET_FOLLOWUP_QUESTIONS";
export const SET_IDV_BTN_DISABLE = "SET_IDV_BTN_DISABLE";
export const LOCKED_BROWSER_BACK = "LOCKED_BROWSER_BACK";
export const UPDATE_BANK_ACCOUNT_LIST = "UPDATE_BANK_ACCOUNT_LIST";



